import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  download: 'Download',
  errorTitle: 'Preview Unavailable',
  errorMessage:
    'There was an error loading your invoice, please refresh the page and try again.',
  preview: 'Preview',
})
